export const TAG_COLORS = {
  active: 'green',
  published: 'green',
  scheduled: 'blue',
  expired: 'grey',
  draft: 'orange',
  modified: 'orange',
  deleted: 'red',
};
